
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/power-independence",
      function () {
        return require("private-next-pages/power-independence/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/power-independence"])
      });
    }
  